import { SelectOption } from '../../shared/Select';

export const getDurationLabelByValue = (value: string, array: SelectOption[]): string => {
  return array[array.map((option) => option.value).indexOf(value)].label;
};
